import { inject } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ErrorHandlerService } from '../services/app-error-handler.service';
import { AuthTokenService } from '../services/app-auth-token.service';

export const SKIP_ERROR_REDIRECT = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(ErrorHandlerService);
  const router = inject(Router);
  const tokenService = inject(AuthTokenService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 409) {
        return throwError(() => error);
      }

      const errorMessage = errorHandler.handle(error);
      console.error('API Error:', {
        url: req.url,
        method: req.method,
        status: error.status,
        message: errorMessage,
        error,
      });

      switch (error.status) {
        case 401:
        case 403:
        case 404:
        case 500:
        case 502:
        case 503:
          if (!req.context.get(SKIP_ERROR_REDIRECT)) {
            void router.navigate(['/error'], {
              state: {
                statusCode: error.status,
                message: errorMessage,
              },
            });
          }
          break;
      }

      return throwError(() => error);
    }),
  );
};
